export default {
  SET_DOCUMENT(state, documents) {
    state.documents = documents
  },
  SET_DOCUMENT_COUNT(state, count) {
    state.documentsCount = count
  },
  REMOVE_RECORD(state, itemId) {
    const documentIndex = state.documents.findIndex(u => u.id === itemId)
    state.documents.splice(documentIndex, 1)
  }
}
